import type { FilmTitle } from "@/types/film";
import TitleCard from "@/components/feature/TitleCard";

interface TitleGridProps {
  items: FilmTitle[];
  className?: string;
}

export default function TitleGrid({ items, className = "" }: TitleGridProps) {
  return (
    <div
      className={`grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-5 ${className}`}
    >
      {items.map((item) => (
        <TitleCard key={item.id} item={item} />
      ))}
    </div>
  );
}